module.exports = __webpack_public_path__ + "static/media/background.474561da.jpg";